import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminActiveEmployeesAdapter } from './adapters/adminKpiAdapters';

export const adminActiveEmployeesConfig: WidgetConfig = {
  id: 'admin-active-employees',
  title: 'Active Employees',
  icon: 'groups',
  category: 'statistics',
  description: 'Number of currently active employees',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 4,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminActiveEmployeesWidget() {
  const dataQuery = useAdminActiveEmployeesAdapter();

  return (
    <SharedKPIWidget
      config={adminActiveEmployeesConfig}
      dataQuery={dataQuery}
      color="primary"
    />
  );
}
